<template>
  <div id="app">
    <img src="./assets/img/page_bgi_2.jpg" class="bgi">
    <my-header v-if="!$route.meta.notKeepHeader"></my-header>
    <!-- 5号坑头部 -->
    <five-header v-if="$route.meta.path"></five-header>
    <keep-alive>
      <router-view v-wechat-title="'金沙遗址博物馆微服务平台'" v-if="$route.meta.keepAlive" :key="$route.fullPath" class="contnet"></router-view>
    </keep-alive>
    <router-view v-wechat-title="'金沙遗址博物馆微服务平台'" v-if="!$route.meta.keepAlive" :key="$route.fullPath" class="contnet"></router-view>
    <!-- footer -->
    <my-footer></my-footer>
  </div>
</template>
<script>
import header from '@/components/common/header'
import footer from '@/components/common/footer'
import fiveheader from '@/view/guide/fiveDetail/section/fiveheader'
export default {
    name: 'App',
    provide () {
        return {
            app: this
        }
    },
    components: {
        'my-header': header,
        'my-footer': footer,
        'five-header': fiveheader
    },
    data () {
        return {
            isRouterAlive: true
        }
    }
}

</script>
<style lang="scss">
.van-list__finished-text {
    display: block;
    margin: 0 auto;
    font-weight: 400;
}
</style>
<style lang="scss">
.bgi {
  width: 100%;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
#app{
  width: 100%;
  // height: 100%;
  overflow: hidden;
  font-size: 28px;
  position: relative;
}
.contnet {
  min-height: calc(100vh - 180px);
}
/* 自定义颜色 */
#nprogress .bar {
  background-color: $base-color !important;
}

.demo-enter-active,
.demo-leave-active {
  transition: 0.3s ease-out;
}

.demo-enter {
  opacity: 0;
}

.demo-leave-to {
  opacity: 0;
}
.rich_text {
  font-size: 30px;
  line-height: 48px;
  letter-spacing: 1.5px;
  img {
    margin: 10px auto;
    display: block;
    width: auto;
  }
}
.danhang {
  overflow: hidden;
  /*超出部分隐藏*/
  white-space: nowrap;
  /*禁止换行*/
  text-overflow: ellipsis;
  /*省略号*/
}

.duohang2 {
  display: -webkit-box;
  /* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
  -webkit-box-orient: vertical;
  /* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
  text-overflow: ellipsis;
  /* 可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.duohang3 {
  display: -webkit-box;
  /* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
  -webkit-box-orient: vertical;
  /* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
  text-overflow: ellipsis;
  /* 可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
  -webkit-line-clamp: 3;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue